"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSectionAsBlocks = exports.renderSectionAsTable = exports.defaultSection = exports.endDocumentSection = exports.ongoingSection = exports.notesSection = exports.indicatorSection = exports.renderCommentSection = exports.infoSection = void 0;
const utils = require("../utils");
const renderContent = require("./content");
// import debug from 'debug';
// const debugLog = debug('reporting:info');
// const verboseLog = debug('reporting:verbose');
// const errorLog = debug('reporting:error');
// const warnLog = debug('reporting:warning');
const FALLBACK_VALUE = '-';
function renderSection(title, content) {
    return [
        { text: title, style: 'sectionTitle' },
        {
            columns: [
                {
                    table: {
                        widths: [450],
                        body: [[content]],
                    },
                    style: 'sectionContainer',
                    layout: 'noBorders',
                    width: 450,
                },
            ],
        },
    ];
}
function infoSection(section) {
    var _a;
    const data = section.data[0];
    const address = [
        utils.concatIfDef(data.street, '\n'),
        `${utils.concatIfDef(data.city, ', ')}${utils.concatIfDef(data.province, ' ')}${data.postal}`,
    ];
    const sectionContent = {
        table: {
            widths: ['auto', '*', 'auto', '*'],
            body: [
                ['First Name:', data.fname || '-', 'Last Name:', data.lname || '-'],
                ['Address:', address || '-', 'Phone:', ((_a = data.phone) === null || _a === void 0 ? void 0 : _a.toString()) || '-'],
                [
                    'EMR ID:',
                    data.patientNumber || '-',
                    'Birth Date:',
                    data.dob ? utils.dateToString(data.dob) : '-',
                ],
                [
                    'Join Date:',
                    data.created_at ? utils.dateToString(data.created_at) : '-',
                    'Language:',
                    data.language || '-',
                ],
            ],
        },
        style: 'patientInfoSection',
        layout: 'noBorders',
    };
    return renderSection(section.title || 'TITLE NOT FOUND', sectionContent);
}
exports.infoSection = infoSection;
function renderCommentSection(section) {
    const content = [];
    content.push(renderContent.sectionTitleContent(section.title || 'TITLE NOT FOUND'));
    for (const subtitle of section.subtitles) {
        content.push(renderContent.subtitle(subtitle));
        for (const datum of section.data) {
            content.push(renderContent.defaultContent(datum[subtitle]));
        }
    }
    return content;
}
exports.renderCommentSection = renderCommentSection;
const excludedIndicatorColumns = [
    'ID of reading',
    'Aetonix Patient ID',
    'Units',
    'Manually Entered?',
    'Date Submitted',
];
function indicatorSection(section) {
    section.subtitles = section.subtitles.filter((subtitle) => !excludedIndicatorColumns.includes(subtitle));
    // Split up the comments
    section.data.map((datum) => {
        datum['Comment'] = splitUpLongWords(datum['Comment'], 21);
        return datum;
    });
    return renderSectionAsTable(section);
}
exports.indicatorSection = indicatorSection;
function splitUpLongWords(text, maxLength) {
    if (typeof text !== 'string')
        return text;
    return text
        .split(' ')
        .map((word) => {
        var _a;
        return word.length < 21
            ? word
            : (_a = word.match(new RegExp('.{1,' + maxLength + '}', 'g'))) === null || _a === void 0 ? void 0 : _a.join('\u200b');
    });
}
function notesSection(section) {
    const content = section.data.map((entry) => {
        var _a;
        const hasBeenUpdated = new Date(entry['Updated At']).getTime() ===
            new Date(entry['Created At']).getTime();
        const updatedAtString = hasBeenUpdated
            ? `Last Updated ${entry['Updated At']} by ${utils.getUserName((_a = entry['Edited By']) === null || _a === void 0 ? void 0 : _a.at(-1))}`
            : `Created At ${entry['Created At']} by ${utils.getUserName(entry['Created By'])}`;
        const noteData = [
            { text: updatedAtString, style: { fontSize: 10 } },
        ];
        if (entry['Title']) {
            noteData.push(renderContent.subtitle('Title:'));
            noteData.push(renderContent.textContent(entry['Title']));
        }
        if (entry['Body']) {
            noteData.push(renderContent.subtitle('Body:'));
            noteData.push(renderContent.textContent(entry['Body']));
        }
        if (entry['Files'] && entry['Files'].length) {
            noteData.push(renderContent.subtitle('Files:'));
            noteData.push(renderContent.defaultContent(entry['Files']));
        }
        if (noteData.length === 1) {
            noteData.push(renderContent.textContent('No data'));
        }
        if (noteData.length === 1)
            noteData.push(`Note contained no data`);
        return {
            stack: [
                {
                    table: {
                        widths: [450],
                        body: noteData.map((row) => [row]),
                    },
                    style: 'blockSection',
                    layout: 'noBorders',
                },
            ],
        };
    });
    return renderSection(section.title || 'TITLE NOT FOUND', content);
}
exports.notesSection = notesSection;
function ongoingSection( /*section: RawSection*/) {
    throw new Error(`Function ongoingSection is not implemented`);
}
exports.ongoingSection = ongoingSection;
function endDocumentSection( /*section: RawSection*/) {
    return 'COPYRIGHT AETONIX';
}
exports.endDocumentSection = endDocumentSection;
const sectionsToIgnore = ['Updated At', 'Created At'];
function defaultSection(section) {
    const content = section.data.map((entry) => {
        var _a;
        const entryContent = [];
        const hasBeenUpdated = new Date(entry['Updated At']).getTime() ===
            new Date(entry['Created At']).getTime();
        const updatedAtString = hasBeenUpdated
            ? `Submission Last Updated ${entry['Updated At']} by ${utils.getUserName((_a = entry['Edited By']) === null || _a === void 0 ? void 0 : _a.at(-1))}`
            : `Submission Created At ${entry['Created At']} by ${utils.getUserName(entry['Created By'])}`;
        entryContent.push(updatedAtString);
        for (const subtitle of section.subtitles) {
            if (!sectionsToIgnore.includes(subtitle) && entry[subtitle]) {
                entryContent.push(renderContent.subtitle(subtitle));
                entryContent.push(renderContent.defaultContent(entry[subtitle]));
            }
            // have an else to display if we want to see empty actions
        }
        if (entryContent.length === 1)
            entryContent.push(`This submission contained no data`);
        return {
            stack: [
                {
                    table: {
                        widths: [450],
                        body: entryContent.map((row) => [row]),
                    },
                    style: 'blockSection',
                    layout: 'noBorders',
                },
            ],
        };
    });
    return renderSection(section.title || 'TITLE NOT FOUND', content);
}
exports.defaultSection = defaultSection;
function renderSectionAsTable(section, widths) {
    const body = [];
    const subtitles = section.subtitles;
    body.push(subtitles);
    for (const entry of section.data) {
        const row = [];
        for (const subtitle of subtitles) {
            const datum = entry[subtitle];
            if (datum) {
                row.push(renderContent.defaultContent(datum));
            }
        }
        body.push(row);
    }
    // if (!section.data.length) {
    // 	body.push(Array(subtitles.length).fill("-"));
    // }
    if (body.length === 1) {
        // If we only have the subtitles, give it a single row
        body.push(Array(subtitles.length).fill(FALLBACK_VALUE));
    }
    const sectionContent = {
        table: {
            headerRows: 1,
            widths: widths || Array(subtitles.length).fill('auto'),
            body,
        },
        style: 'defaultTable',
    };
    return renderSection(section.title || 'TITLE NOT FOUND', sectionContent);
}
exports.renderSectionAsTable = renderSectionAsTable;
function renderSectionAsBlocks(section) {
    const subtitles = section.subtitles;
    const sectionContent = section.data.map((datum) => renderBlockSection(datum, subtitles));
    return renderSection(section.title || 'TITLE NOT FOUND', sectionContent);
}
exports.renderSectionAsBlocks = renderSectionAsBlocks;
function renderBlockSection(data, subtitles) {
    const body = [];
    for (const subtitle of subtitles) {
        if (data[subtitle] != undefined) {
            // const subtitleText = subtitle.length > 123456 ? `${subtitle.slice(0, 1234)}\n${subtitle.slice(1234)}` : subtitle;
            const subtitleContent = renderContent.subtitle(subtitle);
            const content = renderContent.defaultContent(data[subtitle]);
            body.push([subtitleContent, content]);
        }
    }
    if (!body.length) {
        body.push(Array(subtitles.length).fill('-'));
    }
    return {
        stack: [
            {
                table: {
                    widths: [100, 350],
                    body,
                },
                style: 'blockSection',
                layout: 'noBorders',
            },
        ],
    };
}
//# sourceMappingURL=sections.js.map